import { InitialState } from '../server/utils/initialState'

export const initialState: InitialState = window.__initialState || {
  client: {},
  apiConfig: {},
  version: {},
  reactAppOverrides: {},
}
